import { render } from "./j-empty.vue?vue&type=template&id=116fc79d&scoped=true"
import script from "./j-empty.vue?vue&type=script&lang=js"
export * from "./j-empty.vue?vue&type=script&lang=js"

import "./j-empty.vue?vue&type=style&index=0&id=116fc79d&lang=less&scoped=true"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116fc79d"]])

export default __exports__